import { PropsWithChildren, useMemo, useReducer } from 'react';
import { useIsFetching } from '@tanstack/react-query';
import {
  CheckoutFormContext,
  CheckoutFormState,
  CheckoutFormStateAction,
  DEFAULT_CHECKOUT_FORM_STATE,
} from './context';

const reducer = (state: CheckoutFormState, action: CheckoutFormStateAction) => {
  switch (action.type) {
    case 'SET_DEBOUNCING':
      return {
        ...state,
        isDebouncing: action.payload,
      };
    case 'SET_ERROR':
      return {
        ...state,
        isError: action.payload,
      };
    case 'SET_QUERY':
      return {
        ...state,
        query: action.payload,
      };
    default:
      return state;
  }
};

export function CheckoutFormProvider({ children }: PropsWithChildren) {
  const [state, dispatch] = useReducer(reducer, DEFAULT_CHECKOUT_FORM_STATE);

  const isFetching = useIsFetching({
    queryKey: ['checkout-data'],
    exact: false,
  });

  const contextValue = useMemo(
    () => ({
      state: {
        ...state,
        isFetching: isFetching > 0,
      },
      dispatch,
    }),
    [state, dispatch, isFetching],
  );

  return (
    <CheckoutFormContext.Provider value={contextValue}>
      {children}
    </CheckoutFormContext.Provider>
  );
}
